import _ from 'underscore';
import {Events} from 'backbone';

class ApplicationClass {
    constructor() {
        this.Forms = {};
        this.Views = {};
        this.Models = {};
        Object.assign(this, Events);
    }
}

var Application = window.Application = window.Application || new ApplicationClass();

export default Application;

